export default __webpack_public_path__ + "static/media/cart-03.e0902733.jpg";